export default "__VITE_ASSET__ByZwkXc$__"